// src/lib/mobileTopbar.js — Topbar mobile unificada (P2 · ilha flutuante).
import { esc } from './dom.js';
import './mobileTopbar.css';

function _saudacao() {
  const h = new Date().getHours();
  return h < 12 ? 'Bom dia' : h < 18 ? 'Boa tarde' : 'Boa noite';
}
function _dataAbrev(comHora) {
  const d = new Date();
  const dia = d.toLocaleDateString('pt-BR', { weekday: 'short' }).replace('.', '');
  const dm = d.toLocaleDateString('pt-BR', { day: 'numeric', month: 'short' }).replace('.', '');
  let s = `${dia} · ${dm}`;
  if (comHora) s += ' · ' + d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  return s;
}

export function mountMobileTopbar({ nome, avatarUrl, badge = 0, comHora = false, onAvatar, onBell } = {}) {
  let bar = document.getElementById('mobile-topbar');
  if (!bar) { bar = document.createElement('div'); bar.id = 'mobile-topbar'; document.body.appendChild(bar); }
  const prim = (nome || '').split(' ')[0] || '';
  const inits = (nome || '?').split(' ').slice(0, 2).map((w) => w[0] || '').join('').toUpperCase() || '·';
  const avInner = avatarUrl ? `<img src="${esc(avatarUrl)}" alt="">` : esc(inits);
  bar.innerHTML = `
    <div class="mtb-island">
      <button class="mtb-av" data-mtb="avatar" aria-label="Perfil"><span>${avInner}</span></button>
      <div class="mtb-txt">
        <h2>${esc(_saudacao())}${prim ? ', ' + esc(prim) : ''}</h2>
        <div class="d">${esc(_dataAbrev(comHora))}</div>
      </div>
      <button class="mtb-btn" data-mtb="theme" aria-label="Alternar tema"><svg viewBox="0 0 24 24"><path d="M21 12.8A9 9 0 1 1 11.2 3 7 7 0 0 0 21 12.8z"/></svg></button>
      <button class="mtb-btn" data-mtb="bell" aria-label="Notificações"><svg viewBox="0 0 24 24"><path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9M13.7 21a2 2 0 0 1-3.4 0"/></svg>${badge > 0 ? `<span class="mtb-badge">${badge > 9 ? '9+' : badge}</span>` : ''}</button>
    </div>`;
  bar.querySelector('[data-mtb="avatar"]').onclick = () => onAvatar && onAvatar();
  bar.querySelector('[data-mtb="bell"]').onclick = () => onBell && onBell();
  bar.querySelector('[data-mtb="theme"]').onclick = () => {
    const lt = document.documentElement.classList.toggle('light');
    try { localStorage.setItem('angular-theme', lt ? 'light' : 'dark'); } catch (_) {}
  };
}

export function unmountMobileTopbar() {
  document.getElementById('mobile-topbar')?.remove();
}
